import io from 'socket.io-client';
import { SOCKET, Event, sendNotfication } from "./Helper";
import storage from "../src/Storage";  // Unused in this snippet, but kept for completeness

/**
 * Socket URL
 */
const ws = SOCKET;

/**
 * Initialize Socket Connection
 */
const socket = io(ws, {
  // Removed: withCredentials (handle via server CORS)
  // Removed: extraHeaders (use auth or query params instead)
  auth: {
    "my-custom-header": "abcd"  // If auth-related; otherwise, use io(ws + '?my-custom-header=abcd')
  }
});

/*
 * Auto Login By Reload
 * TODO
 */
socket.on('connect', () => {
  Event.emit('connect');
});

/*
 * Disconnect Server
 */
socket.on('disconnect', () => {
  Event.emit('disconnect');
  sendNotfication('Connection Lost, Trying to connect...', 'danger', 'top-center');
});

export default socket;